export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/carousel_arrow_left.5d81a27b.svg","height":45,"width":44,"blurWidth":0,"blurHeight":0};